module.exports = __webpack_public_path__ + "img/6000.0088c106.jpg";